/**
 * Outgoing mail configuration (RBAC area: admin-only).
 *
 * PSA sends email through Microsoft Graph for several distinct "functions" (invoices,
 * customer reports, internal reports). The Graph *credentials* (tenant/client/secret)
 * are server config, but the *from* mailbox each function sends as is admin-managed in
 * the UI: a single default sender plus optional per-function overrides. With application
 * Mail.Send the app may send as any mailbox in the tenant.
 *
 * Keep this file free of runtime framework dependencies (shared by backend + frontend).
 */
/** The distinct email-sending functions whose `from` address can be configured. */
export const MAIL_FUNCTIONS = [
    'invoice',
    'customer_report',
    'report',
    'notification',
    'onboarding',
    'timesheet_approval',
    'quote',
    'agreement_overage',
];
export const MAIL_FUNCTION_LABELS = {
    invoice: 'Invoices',
    customer_report: 'Customer Reports',
    report: 'Internal Reports',
    notification: 'Notifications',
    onboarding: 'Onboarding',
    timesheet_approval: 'Timesheet Approvals',
    quote: 'Quotes',
    agreement_overage: 'Catalyst+ Overage Alerts',
};
//# sourceMappingURL=mail.js.map